import { useDispatch, useSelector } from 'react-redux';
import { StartupActions } from '../../Redux/StartupRedux';
import { useHistory } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';

const LoginPage = ({}) => {
  const dispath = useDispatch();
  const navigate = useHistory();
  const [form, setForm] = useState({});
  const [errorMessage, setErrorMessage] = useState('');
  const user = useSelector((state) => state.app.user);
  const loading = useSelector((state) => state.app.loading);

  useEffect(() => {
    if (!loading && user) {
      window.location.href = '/';
    }
  }, [loading]);
  const handleForm = (value, id) => {
    form[id] = value;
    setForm({ ...form });
  };

  const handleLogin = (e) => {
    e.preventDefault();
    axios
      .post('/api/v1/login', { ...form })
      .then(({ data }) => {
        if (data.success) {
          dispath(StartupActions.setUser(data.payload.user));
          navigate.push('/');
        } else {
          setErrorMessage(data.errors.common);
        }
      })
      .catch(() => {
        setErrorMessage('Cannot log in, please try again!');
      });
  };
  return (
    <>
      <section class="items-center flex bg-[url('../images/login_bg.jpg')] bg-cover bg-center relative py-20 min-h-screen">
        <div class='bg-[#0d0f14]/25 absolute inset-0 backdrop-blur-md'></div>
        <div class='container relative'>
          <div class='grid grid-cols-1'>
            <div class='max-w-[450px] mx-auto'>
              <a href='index_1.html'>
                <img
                  src='https://dyuniair.com/wp-content/uploads/2023/04/z4271980275541_9a6654855cf1c1ca0c821c110a4d0a46-removebg-preview.png'
                  alt='logo'
                  class='mx-auto'
                  style={{ height: 100 }}
                />
              </a>
            </div>
          </div>
          <div class='grid grid-cols-1 mt-16'>
            <div class='max-w-[450px] mx-auto py-10 px-8 rounded-xl bg-white w-full'>
              <h4 class='font-bold text-2xl mb-2 text-center capitalize'>
                Login
              </h4>
              <p class='text-muted text-center'>Login to see fans!</p>
              <form class='mt-6 space-y-4'>
                <div>
                  <label class='font-bold'>Email/Phone number</label>
                  <input
                    type='text'
                    class='form-input mt-2 rounded !bg-white border border-[#ced4da] text-base focus:border-custom'
                    placeholder='Email'
                    onChange={(e) => {
                      handleForm(e.target.value, 'phone_number');
                    }}
                  />
                </div>
                <div>
                  <label class='font-bold'>Password</label>
                  <input
                    type='password'
                    class='form-input mt-2 rounded !bg-white border border-[#ced4da] text-base focus:border-custom'
                    placeholder='Password'
                    onChange={(e) => {
                      handleForm(e.target.value, 'password');
                    }}
                  />
                  <span style={{ color: 'red' }}>{errorMessage}</span>
                </div>
                <div>
                  <button
                    type='submit'
                    class='btn-custom w-full'
                    onClick={handleLogin}
                  >
                    Login
                  </button>
                </div>
              </form>
              <div class='mt-4 text-center'>
                <a href='#' class='font-bold'></a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default LoginPage;
